<template>
  <div class="hero">
    <div class="hero-content d-flex justify-content-center align-items-center">
      <h1>Árnyékguru Blog - A redőnyök használatáról és a gurtniról 📖</h1>
    </div>
  </div>
  <div class="blog-body">
    <h1 data-aos="fade-up"><i class="bi bi-tools"></i> A redőnyök helyes használata és a gurtni cseréjének fontossága</h1>
    <img src="../../public/static/assets/blog/gurtni/kulso-tokos-redony.jpg" alt="Redonyjavitas Veszprem" data-aos="zoom-in" data-aos-duration="600">

    <p data-aos="fade-up" data-aos-delay="100">A redőnyök nem csupán praktikus árnyékoló eszközök, hanem hozzájárulnak otthonunk kényelméhez és biztonságához is. Egy jól működő redőny javítja a hőszigetelést, védi a nyílászárókat, és nem utolsó sorban esztétikai értéket is képvisel. Viszont ahhoz, hogy a redőny hosszú éveken át hibamentesen működjön, elengedhetetlen a helyes használat és a rendszeres karbantartás, különösen a gurtni esetében.</p>

    <h2 data-aos="fade-up"><i class="bi bi-wrench"></i> Mire figyelj a redőny használatakor?</h2>

    <p data-aos="fade-up" data-aos-delay="100">A redőny mozgatása során számos olyan apróság van, amire érdemes figyelni, hogy elkerüljük a meghibásodásokat:</p>
    <ul>
      <li><strong>Lassan, egyenletesen húzd!</strong> A hirtelen, rángató mozdulatok károsíthatják a gurtni mechanizmusát és a redőny tokját is.</li>
      <li><strong>Elakadás esetén állj meg!</strong> Ne próbáld meg erőltetni a lehúzást vagy felhúzást, inkább ellenőrizd, nem akadt-e meg valami a redőnylécek között vagy a sínben.</li>
      <li><strong>Zajos működés jelezheti a problémát.</strong> Ha a redőny kattog vagy recseg, az kopásra vagy a kenés hiányára utalhat. Motoros redőnyöknél ez különösen fontos figyelmeztető jel lehet.</li>
      <li><strong>Nem tart a redőny? Lehet, hogy az automata rugója gyengült el.</strong> Ebben az esetben az egész automata cseréje szükséges, de ez általában egyszerűen kivitelezhető feladat.</li>
      <li><strong>Extrém időjárás esetén:</strong> erős szélben vagy viharban ne hagyd középállásban a redőnyt – az kilazíthatja a lamellákat vagy akár le is szakíthatja azokat.</li>
      <li><strong>Ügyelj a mozgástérre!</strong> A párkányon hagyott tárgyak vagy kívülre felszerelt dekorációk zavarhatják a redőny akadálytalan mozgását.</li>
    </ul>

    <img src="../../public/static/assets/blog/gurtni/redony-felepitese.jpg" alt="Veszprém és környéke Redőnyjavítás">

    <h2><i class="bi bi-link-45deg"></i> Miért fontos a gurtni cseréje?</h2>

    <p>A gurtni az a textilszalag, amely a redőny mozgatását biztosítja. Mivel ezt naponta akár többször is használjuk, természetes, hogy idővel elhasználódik. A cseréje nem csak esztétikai szempontból fontos, hanem működésbiztonsági okokból is.</p>

    <h3><i class="bi bi-hourglass-split"></i> Milyen jelek utalnak arra, hogy esedékes a csere?</h3>
    <ul>
      <li><strong>Foszladozó vagy bolyhosodó szövet:</strong> ez az első figyelmeztetés, hogy a gurtni szerkezete gyengül.</li>
      <li><strong>Látható elvékonyodás:</strong> ez már a szakadás előjele lehet. Ha elszakad, akár a redőnyszekrény vagy más alkatrészek is megsérülhetnek.</li>
      <li><strong>Elszíneződés és szennyeződés:</strong> bár inkább esztétikai probléma, a koszos gurtni jobban elcsúszik a kézben és a görgőn is.</li>
      <li><strong>Gurtni csavarodása vagy megakadása:</strong> ez a vezetőgörgő vagy más alkatrész hibájára utalhat, amit szintén orvosolni kell.</li>
    </ul>

    <img src="../../public/static/assets/blog/gurtni/redony-automata.png" alt="Gurtnicsere Veszprém">

    <div class=”tip”>
      <i class=”bi bi-lightbulb”></i> Tipp: hamarosan jövünk a következő bejegyzéssel – „Mire figyeljünk, ha új redőnyt szeretnénk?” témában!
    </div>

    <h2><i class="bi bi-bookmark"></i> Összefoglalás</h2>

    <p>A redőny akkor szolgálja legjobban otthonunkat, ha rendszeresen karban van tartva. A megfelelő használat, az időben történő gurtni- és alkatrészcsere nemcsak hosszabb élettartamot biztosít, de megelőzi a nagyobb, költségesebb javításokat is. Ne várd meg, míg probléma lesz – figyelj az apró jelekre, és cselekedj időben!</p>
    <img src="../../public/static/assets/ruined-shutter.jpg" alt="Leszakadt redony Veszprem">
    <div class="tip">
      <i class="bi bi-hammer"></i> Amennyiben sajnos a gurtni megadta magát, keressen bennünket. Kiszállok, megjavítom és már lehet is használni!
    </div>
    <div class="d-flex justify-content-center">
      <PhoneComponent/>
    </div>
  </div>
</template>

<script>

import PhoneComponent from "@/components/PhoneComponent.vue";

export default {
  name: 'GurtniPage',
  data() {
    return {
    };
  },
  components: {
    PhoneComponent
  }
}

</script>

<style scoped lang="scss">
@use '@/assets/style/variables';

.header-placeholder {
  height: 65px;
}

.hero {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 500px;
}


.hero::before {
  content: "";
  position: absolute;
  top: 0px;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(../../public/static/assets/blog/gurtni/hero.png);
  background-repeat: no-repeat;
  background-position: center bottom 25%;
  filter: brightness(80%);
  background-attachment: fixed;
  background-size: cover;
}

.hero-content {
  position: relative;
  color: variables.$light-color;
  padding:20px;
}

@media screen and (max-width: 800px) {
  .hero {
    background: url(../../public/static/assets/blog/gurtni/hero.png);
    background-size: cover;
    height: 300px;
  }

  .hero::before {
    background: none !important;
  }
  
  .hero-content {
    position: relative;
    color: variables.$light-color;
    padding:20px;
    background: #000;
    opacity: 0.5;
    width: 100%;
    height: 100%;
  }
}

.blog-body {
  font-family: 'Roboto', sans-serif;
  background-color: #fdfdfd;
  color: #333;
  max-width: 1000px;
  margin: 0 auto;
  padding: 40px 20px;
  line-height: 1.75;
  font-size: 1.125rem;
  text-align: justify;

  h1 {
    color: #155692;
    text-align: left;
    margin: 0 0 32px 0;
    font-size: 2.5rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.5px;
  }

  h2 {
    color: #155692;
    text-align: left;
    margin: 48px 0 24px 0;
    font-size: 1.875rem;
    font-weight: 600;
    line-height: 1.3;
    letter-spacing: -0.3px;
  }

  h3 {
    color: #1a6ab0;
    text-align: left;
    margin: 32px 0 16px 0;
    font-size: 1.375rem;
    font-weight: 600;
  }

  p {
    margin: 16px 0 20px 0;
    color: #444;
  }

  img {
    max-width: 100%;
    border-radius: 12px;
    display: block;
    margin: 32px auto;
    text-align: center;
    box-shadow: 0 4px 12px rgba(21, 86, 146, 0.08);
  }

  .tip {
    background: linear-gradient(135deg, #f0f6fc 0%, #eef4fa 100%);
    border-left: 5px solid #bf6a1d;
    padding: 20px 20px;
    margin: 32px 0;
    font-style: italic;
    border-radius: 8px;
    line-height: 1.7;
    color: #3a3a3a;
  }

  section {
    margin: 40px 0;
  }

  ul {
    margin: 20px 0;
    padding-left: 0;
  }

  li {
    padding: 24px;
    margin-bottom: 20px;
    list-style-type: none;
    background-color: #f9fbfd;
    border-left: 4px solid #155692;
    border-radius: 6px;
    transition: box-shadow 0.3s ease, transform 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(21, 86, 146, 0.12);
      transform: translateY(-2px);
    }

    strong {
      color: #155692;
      font-size: 1.15rem;
      display: block;
      margin-bottom: 12px;
    }

    p {
      margin: 12px 0;
      font-size: 1.1rem;
      line-height: 1.7;
    }
  }

  em {
    color: #666;
    font-style: italic;
    display: block;
    margin: 12px 0 16px 0;
    font-size: 0.95rem;
    letter-spacing: 0.3px;
  }
}
</style>